module.exports = __webpack_public_path__ + "img/home-banner.b62eddb7.png";